export const GET_AVAILABLE_TERMS = 'GET_AVAILABLE_TERMS';

export enum AvailableTermsActionTypes {
  GET_AVAILABLE_TERMS_REQUEST = 'GET_AVAILABLE_TERMS_REQUEST',
  GET_AVAILABLE_TERMS_SUCCESS = 'GET_AVAILABLE_TERMS_SUCCESS',
  GET_AVAILABLE_TERMS_FAILURE = 'GET_AVAILABLE_TERMS_FAILURE'
}
